import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { changePassword } from '../services/loginservice'
import Loader from '../images/whiteloader.svg';
import { getSession } from '../global';


const ChangePassword = () => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector(state => state.appData);
    const history = useHistory();

    const d = {
        oldpass: '',
        newpass: '',
        confirmpass: ''
    };

    const [data, setData] = useState(d);
    const [isValidPass, setIsValidPass] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!getSession('userInfo')) {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onChange = async () => {

        if (!isValidPass || (data.newpass != data.confirmpass)) {
            alert('Invalid Password');
            return;
        }
        setLoading(true);
        // public int Id { get; set; }
        // public string OldPass { get; set; }
        // public string NewPass { get; set; }
        const d = {
            id: userInfo.id,
            oldPass: data.oldpass,
            newPass: data.newpass
        }
        const rs = await changePassword(d);
        setLoading(false);


        if (rs.ok) {
            history.push('/login');
        } else {
            alert(rs.msg);
        }
    }

    const checkPassword = (str) => {
        var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return re.test(str);
    }

    return userInfo && <div className="container" style={{ padding: 10 }}>
        <div className='text-center'>
            <h1>Change Password</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-12">
                    <label>Old Password</label>
                    <input type="password" className="form-control" value={data.oldpass} onChange={e => updateData('oldpass', e.target.value)} />
                </div>
                <div className="col-12">
                    <label>New Password</label>
                    <input type="password" className="form-control" value={data.newpass} onChange={e => updateData('newpass', e.target.value)} onBlur={(e) => {
                        const val = e.target.value;
                        if (val) {
                            setIsValidPass(checkPassword(val));
                        }
                    }} />
                    {
                        !isValidPass && <p style={{ color: 'red' }}>Password must be atlest 8 character long 1 upper & 1 lower case, 1 special and 1 numeric!</p>
                    }
                </div>
                <div className="col-12">
                    <label>Confirm Password</label>
                    <input type="password" className="form-control" value={data.confirmpass} onChange={e => updateData('confirmpass', e.target.value)} />
                    {
                        data.confirmpass && data.newpass != data.confirmpass && <p style={{ color: 'red' }}>Password not matched</p>
                    }
                </div>
                <div className="col-12 mt-2">
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button type='button' className='btn btn-primary' disabled={!data.oldpass || !data.newpass || !data.confirmpass || loading} onClick={onChange}>
                            {loading ? (
                                <img
                                    src={Loader}
                                    height='30'
                                />
                            ) : (
                                'Change Password'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default ChangePassword;